<template>
  <v-app id="app">
    <NavMenu />
    <TopBar id="top-bar" />
    <v-main class="view-height-minus-toolbar">
      <GlobalProgressBar />
      <v-container id="canvas" class="h-100" fluid>
        <router-view :key="routePath" />
        <notifications
          class="pt-1"
          group="default"
          position="top right"
          :pause-on-hover="true"
        />
      </v-container>
    </v-main>
    <FatalErrorModal v-if="showFatalErrorModal" :activator="showFatalErrorModal" />
    <DeviceDialogModal :activator="showDeviceDialogModal" :model="deviceDialogModel" />
    <StoreCardModal
      v-if="showStoreCardModal"
      :activator="showStoreCardModal"
      @toggle-dialog="toggleStoreCardModal"
    />
    <InstallmentWorksheetModal
      v-if="showInstallmentCalculatorModal"
      :activator="showInstallmentCalculatorModal"
      title="Installment Calculator"
      dashboardMode
      @toggle-installment-modal="toggleInstallmentCalculatorModal"
    />
    <RContextMenu />
  </v-app>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { isIdle } from '@/mixins/isIdle';
import TopBar from '@/components/core/TopBar.vue';
import NavMenu from '@/components/core/menu/NavMenu.vue';
import DeviceDialogModal from '@/components/core/common/DeviceDialogModal';
import FatalErrorModal from '@/components/core/common/FatalErrorModal';
import GlobalProgressBar from '@/components/core/common/GlobalProgressBar';
import RContextMenu from '@/components/core/common/RContextMenu';

/* istanbul ignore next */
const StoreCardModal = defineAsyncComponent(() => import('@/components/core/StoreCardModal.vue'));
/* istanbul ignore next */
const InstallmentWorksheetModal = defineAsyncComponent(() => import('@/components/customer/installmentContract/InstallmentWorksheetModal.vue'));

export default {
  name: 'App',

  components: {
    TopBar,
    NavMenu,
    DeviceDialogModal,
    FatalErrorModal,
    GlobalProgressBar,
    StoreCardModal,
    InstallmentWorksheetModal,
    RContextMenu,
  },

  mixins: [isIdle],

  async created() {
    if (!this.clientSetupData) this.$store.dispatch('meta/getClientSetupData');
    this.$store.dispatch('auth/deviceIntraface', { requestType: 'getDevices' });
    // Prevents user from dropping files and it opening them in Chrome
    window.addEventListener('dragover', (e) => {
      e.preventDefault();
    }, false);
    window.addEventListener('drop', (e) => {
      e.preventDefault();
    }, false);
  },

  computed: {
    routePath() {
      return this.$route.path;
    },

    ...mapGetters({
      clientSetupData: 'meta/clientSetupData',
      showFatalErrorModal: 'notify/showFatalErrorModal',
      showDeviceDialogModal: 'auth/showDeviceDialogModal',
      showStoreCardModal: 'auth/showStoreCardModal',
      showInstallmentCalculatorModal: 'auth/showInstallmentCalculatorModal',
      deviceDialogModel: 'auth/deviceDialogModel',
    }),
  },

  methods: {
    toggleStoreCardModal() {
      this.$store.dispatch('auth/toggleStoreCardModal');
    },
    toggleInstallmentCalculatorModal() {
      this.$store.dispatch('auth/toggleInstallmentCalculatorModal');
    },
  },
};
</script>
<style lang="scss">
  @import '@/styles/app.scss';

  .view-height-minus-toolbar {
    height: calc(100vh - 64px);
    overflow-y: hidden;
  }

  #canvas {
    padding: 0;
  }
</style>
